import React from 'react'
import hydraFacialImg from "./../../../../Images/FacialPage/Hydra Lifting Ocean Miracle.png";

const HydraFacialImg = () => {
  return (
    <div className="facialExtImg">
      <img src={hydraFacialImg} alt="hydraFacialImg" />
    </div>
  )
}

export default HydraFacialImg
